import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiChevronDown } from 'react-icons/fi';
import logo from '../assets/pointfinity-logo-mark.png';
import './Navbar.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [legalOpen, setLegalOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setLegalOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const close = () => { setMenuOpen(false); setLegalOpen(false); };

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <div className="navbar__inner container">
        <Link to="/" className="navbar__logo" onClick={close}>
          <img src={logo} alt="Pointfinity" className="navbar__logo-icon" />
          <span>Pointfinity</span>
        </Link>

        <ul className={`navbar__links${menuOpen ? ' navbar__links--open' : ''}`}>
          <li><NavLink to="/" onClick={close} end>Home</NavLink></li>
          <li><a href="/#features" onClick={close}>Features</a></li>
          <li><a href="/#subscription" onClick={close}>Subscription</a></li>
          <li><NavLink to="/download" onClick={close}>Download App</NavLink></li>
          <li><NavLink to="/contact" onClick={close}>Contact</NavLink></li>
          <li className="navbar__dropdown" ref={dropdownRef}>
            <button
              className="navbar__dropdown-btn"
              onClick={() => setLegalOpen(!legalOpen)}
              aria-expanded={legalOpen}
            >
              Legal <FiChevronDown className={`chevron${legalOpen ? ' chevron--open' : ''}`} />
            </button>
            {legalOpen && (
              <ul className="navbar__dropdown-menu">
                <li><NavLink to="/terms" onClick={close}>Terms & Conditions</NavLink></li>
                <li><NavLink to="/privacy" onClick={close}>Privacy Policy</NavLink></li>
                <li><NavLink to="/store-owner-terms" onClick={close}>Store Owner Terms</NavLink></li>
                <li><NavLink to="/customer-terms" onClick={close}>Customer Terms</NavLink></li>
              </ul>
            )}
          </li>
          {/* Get Started button inside mobile menu */}
          {/* <li className="navbar__cta-mobile-wrap">
            <Link to="/contact" className="btn-primary navbar__cta-mobile" onClick={close}>
              Get Started
            </Link>
          </li> */}
        </ul>

        <Link to="/" className="btn-primary navbar__cta" onClick={close}>Get Started</Link>

        <button
          className="navbar__hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>
    </nav>
  );
}
